<template>
  <div class="ranking-list-canceled card">
    <div class="card-header">
      <h4 class="card-title">Ausentes ({{ tickets.length }})</h4>
    </div>
    <div class="card-content">
      <el-table class="table-striped" :data="tickets">
        <el-table-column label="Nome" property="customer" >
          <template slot-scope="scope"> {{ scope.row.customer.holder }} </template>
        </el-table-column>
        <el-table-column label="UC">
          <template slot-scope="scope"> {{ scope.row.customer.uc }} </template>
        </el-table-column>
        <el-table-column label="Nota">
          <template slot-scope="scope" v-if="scope.row.survey && scope.row.survey.data"> {{ scope.row.survey.data.refrigerator.score }} </template>
        </el-table-column>
        <el-table-column label="Posição Inicial">
          <template slot-scope="scope"> {{ scope.row.rankingOriginal }} </template>
        </el-table-column>
        <el-table-column label="Posição de Ausência">
          <template slot-scope="scope"> {{ scope.row.rankingNow }} </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ranking-list-absent',

  props: ['tickets']
}
</script>



// WEBPACK FOOTER //
// src/pages/Ranking/RankingListAbsent.vue